module.exports = __webpack_public_path__ + "img/pr-1.b94f4ec8.png";